import { AbstractMenuStateService } from 'ngx-register-base';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuStateService extends AbstractMenuStateService {
  _isOpen$ = new BehaviorSubject(true);
  isOpen$ = this._isOpen$.asObservable();
  toggleDisabled$ = new BehaviorSubject(false).asObservable();

  get isOpen(): boolean {
    return this._isOpen$.value;
  }

  setOpen(value: boolean): void {
    this._isOpen$.next(value);
  }

  toggle(): void {
    this.setOpen(!this.isOpen);
  }
}
